import React from "react";

// Draw interface artwork as vectors: never depend on text/emoji font fallback.
const paths = {
  'arrow-up': <path d="M12 20V4m-7 7 7-7 7 7" />,
  'arrow-right': <path d="M4 12h16m-7-7 7 7-7 7" />,
  'arrow-up-right': <path d="M5 19 19 5M5 5h14v14" />,
  close: <path d="m6 6 12 12M6 18 18 6" />,
  'chevron-left': <path d="m15 5-7 7 7 7" />,
  'chevron-right': <path d="m9 5 7 7-7 7" />,
  'chevron-down': <path d="m5 9 7 7 7-7" />,
  star: <path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9Z" />,
  'fa-graduation-cap': <><path d="m2 8 10-5 10 5-10 5Z" /><path d="M6 10v7c4 3 8 3 12 0v-7m4-2v9" /></>,
  'fa-briefcase': <><rect x="3" y="7" width="18" height="14" rx="1" /><path d="M8 7V3h8v4M3 12c6 3 12 3 18 0m-9 1v4" /></>,
  'fa-building': <><path d="M5 21V3h14v18M2 21h20M9 7h1m4 0h1M9 11h1m4 0h1M9 15h1m4 0h1m-4 6v-3h2v3" /></>,
  'fa-users': <><circle cx="9" cy="7" r="3" /><path d="M2 21v-3a7 7 0 0 1 14 0v3m0-17a3 3 0 0 1 0 6m3 4c2 .8 3 2.4 3 5v2" /></>,
  'fa-microphone': <><rect x="8" y="2" width="8" height="13" rx="4" /><path d="M5 10v2a7 7 0 0 0 14 0v-2m-7 9v3m-4 0h8" /></>,
  'fa-trophy': <><path d="M7 3h10v7a5 5 0 0 1-10 0Zm0 2H3v3a4 4 0 0 0 4 4m10-7h4v3a4 4 0 0 1-4 4m-5 3v6m-5 0h10" /></>,
  'fa-shield': <path d="m12 2 9 4v6c0 5-5 8-9 10-4-2-9-5-9-10V6Z" />,
  'fa-commenting': <><path d="M21 11a9 8 0 0 1-9 8H6l-4 3 1-7a8 8 0 0 1 0-8 9 8 0 0 1 18 4Z" /><path d="M7 11h.1m5 0h.1m5 0h.1" /></>,
  'fa-bullseye': <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1" /></>,
  location: <><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="3" /></>,
  mail: <><rect x="2" y="4" width="20" height="16" rx="1" /><path d="m2 5 10 8L22 5" /></>,
  globe: <><circle cx="12" cy="12" r="10" /><ellipse cx="12" cy="12" rx="4" ry="10" /><path d="M2 12h20M4 6h16M4 18h16" /></>,
};

export default function InterfaceIcon({ name, size = '1em', style, ...props }) {
  return <svg {...props} data-interface-icon={name} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill={name === "star" ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}>{paths[name]}</svg>;
}
